import { useNavigate } from "react-router";
import Title from "@/shared/components/Title/Title";

import ReverseButton from "@/shared/components/ReverseButton/ReverseButton";

import "../../AppointmentsComponents/AppointmentsHeader/AppointmentsHeader.scss";

export default function StatHeader() {
    const navigate = useNavigate();
    return (
        <header className='appointmen_header header_in_content_component'>
            <ReverseButton
                onClick={() => {
                    navigate("/schedule");
                }}
            />
            <Title tag='h2' text={"Статистика"} />
        </header>
    );
}
